<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>分组列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
        <el-button size="small" type="primary" icon="el-icon-search" @click="refresh()">刷新</el-button>
      </el-form-item>
    </el-form>


    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="listData" highlight-current-row
              v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="selection" width="60"></el-table-column>
      <el-table-column prop="name" label="分组名称"></el-table-column>
      <el-table-column prop="dnum" label="组内设备"></el-table-column>
      <el-table-column prop="tnum" label="执行任务"></el-table-column>
      <el-table-column prop="operation_type" label="分组操作类型">
        <template slot-scope="scope">
          {{ scope.row.operation_type == '1' ? '手动' : '自动' }}
        </template>
      </el-table-column>
      <el-table-column prop="operation_status" label="分组状态">
        <template slot-scope="scope">
          <div class="status" v-if="scope.row.operation_status == '0'">
            <div class="red-bg"></div>
            <span class="status-close">关闭</span>
          </div>
          <div class="status" v-else>
            <div class="green-bg"></div>
            <span class="status-run">运行</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">详情</el-button>
          <el-button size="mini" type="danger" @click="deleteGroup(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="80%" @click="closeDialog">
      <div>
        <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
          <div>
            <p><span>|</span>基本信息</p>
          </div>
          <el-form-item label="分组名称" prop="name" :required="true">
            <el-input size="small" v-model="editForm.name" auto-complete="off"
                      placeholder="分组名称"></el-input>
          </el-form-item>
          <div>
            <p><span>|</span>组内设备</p>
          </div>
          <div style="display: flex;">
            <el-card style="width: 50%;height: 20vh;display: grid;overflow-y: scroll;">
              <p style="margin-top: -10px;">勾选可添加的设备</p>
              <el-checkbox-group v-model="editForm.device_id" @change="handleCheckedDevicesChange">
                <div style="display: grid;">
                  <el-checkbox v-for="d in device1" :label="d.name" :key="d.id"
                               style="padding: 5px 0px;">{{ d.name }}
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </el-card>

            <el-card style="width: 50%;height: 20vh;display: grid;overflow-y: scroll;">
              <p style="margin-top: -10px;">已添加：{{ groupSelectedDevices.length }} 台 <span
                @click="deleteAllDevices"
                style="float: right;color: #0052D9;">全部删除</span>
              </p>
              <div style="display:flex;height: 30px;" v-for="d in groupSelectedDevices">
                <p style="width: 34vw;">{{ d.name }}</p>
                <p style="width:20px;height: 20px;">
                  <el-image src="/static/images/minus-red.png"
                            style="width: 14px;height: 14px;margin-top: 3px;float: right;"
                            @click="deleteCurrentDevice(d.id)"></el-image>
                </p>
              </div>
            </el-card>
          </div>

          <div>
            <p><span>|</span>参数设定</p>
          </div>

          <el-form-item label="设定压力" prop="pressure" :required="true">
            <el-input size="small" v-model="editForm.pressure" auto-complete="off"
                      placeholder="设定压力"></el-input>
            <span style="position: absolute;right: 20px;">MPa</span>
          </el-form-item>

          <el-form-item label="间歇运行" prop="run_time" :required="true">
            <el-input size="small" v-model="editForm.run_time" auto-complete="off"
                      placeholder="间歇运行"></el-input>
          </el-form-item>

          <el-form-item label="间歇停止" prop="stop_time" :required="true">
            <el-input size="small" v-model="editForm.stop_time" auto-complete="off"
                      placeholder="间歇停止"></el-input>
          </el-form-item>

          <el-form-item label="操作模式" prop="mode" :required="true">
            <el-select v-model="editForm.mode" placeholder="请选择操作模式">
              <el-option
                v-for="item in mode"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  deleteCurrentDevice,
  deleteDevices,
  groupDelete,
  groups,
  groupSave,
  groupsDetail,
  unusedDevices
} from '../../api/userMG'
import Pagination from '../../components/Pagination'

export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '新建分组',
      editForm: {
        id: '',
        name: '',
        group_id: '',
        device_id: [],
        mode: '',
        run_time: '',
      },
      mode: [
        {label: '远程&本地', value: 3},
        {label: '远程', value: 2},
        {label: '本地', value: 1},
      ],
      group_id: null,
      // rules表单验证
      rules: {
        name: [
          {required: true, message: '请输入分组名称', trigger: 'blur'}
        ],
        pressure: [
          {required: true, message: '请输入压力', trigger: 'blur'}
        ],
        mode: [
          {required: true, message: '请选择操作模式', trigger: 'blur'}
        ],
        run_time: [
          {required: true, message: '请输入间歇运行时间', trigger: 'blur'}
        ]
      },
      formInline: {
        page: 1,
        limit: 10,
        pageSize: 10,
      },
      // 选择数据
      selectdata: [],
      groupSelectedDevices: [],
      userparm: [], //搜索权限
      listData: [], //用户数据
      groups: [], //左侧勾选添加设备
      selectedDevice: [],
      device1: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},
  /**
   * 创建完毕
   */

  created() {
    this.loading = true
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    // 获取数据方法
    getdata(parameter) {
      this.loading = false
      groups().then(res => {
        if (res.code == 200) {
          this.listData = res.result
        }
      })
    },
    deleteAllDevices() {
      this.$confirm('确定要全部删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = [];
        if (this.groupSelectedDevices.length > 0) {
          this.groupSelectedDevices.forEach(item => {
            ids.push(item.id)
          })
        } else {
          return false;
        }
        deleteDevices({id: ids}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '设备已删除！'
            })
            this.getGroupDetail(this.group_id)
          } else {
            this.$message.error('设备删除失败！')
          }
        })
      })
    },
    deleteCurrentDevice(id) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCurrentDevice({id: id}).then(res => {
          if (res.code == 200) {
            this.$message({
              type: 'success',
              message: '设备已删除！'
            })
            this.getdata()
          } else {
            this.$message.error('设备删除失败！')
          }
        })
      })
    },
    handleCheckedDevicesChange(val) {
      let selected = [];
      if (val) {
        this.device1.forEach(item => {
          val.forEach(item1 => {
            if (item1 == item.name) {
              selected.push(item.id)
            }
          })
        })
        this.device1_id = selected
      }
    },
    getUnselectedDevice() {
      unusedDevices().then(res => {
        if (res.code == 200) {
          this.device1 = res.result
        }
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function (row) {
      this.editFormVisible = true
      this.getUnselectedDevice()
      // 深拷贝并赋值
      if (row != undefined && row != 'undefined') {
        this.title = '修改分组'
        this.group_id = row.id
        this.getGroupDetail(row.id)
      } else {
        this.title = '添加分组'
      }
    },
    getGroupDetail(id) {
      groupsDetail({id: id}).then(res => {
        if (res.code == 200) {
          this.editForm.name = res.result.group.name
          this.editForm.id = res.result.group.id
          if (res.result.params != null) {
            this.editForm.pressure = res.result.params.pressure
            this.editForm.mode = res.result.params.mode
            this.editForm.run_time = res.result.params.run_time
            this.editForm.stop_time = res.result.params.stop_time
          }
          let s_d = [];
          if (res.result.select_device.length > 0) {
            res.result.select_device.forEach(item => {
              s_d.push(item.id);
            })
            this.selectedDevice = s_d;
          }
          this.groupSelectedDevices = res.result.device;
        }
      })
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          let param = {
            id: this.editForm.id,
            name: this.editForm.name,
            device_id: this.device1_id,
            pressure: this.editForm.pressure,
            run_time: this.editForm.run_time,
            stop_time: this.editForm.stop_time,
            mode: this.editForm.mode
          };
          groupSave(param)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '分组保存成功！'
                })
                this.editForm = {
                  id: '',
                  name: '',
                  pressure: '',
                  run_time: '',
                  stop_time: '',
                  mode: '',
                  device_id: []
                }
              } else {
                this.$message({
                  type: 'info',
                  message: '分组保存失败！'
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('分组保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除分组
    deleteGroup(row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        groupDelete({id: row.id})
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '分组已删除！'
              })
              this.getdata(this.formInline)
              this.group_id = null
            } else {
              this.$message({
                type: 'info',
                message: '分组删除失败,请稍后再试！'
              })
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('分组删除失败,请稍后再试！')
          })
      })
        .catch(() => {

        })
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.editForm = {
        id: '',
        name: '',
        pressure: '',
        run_time: '',
        stop_time: '',
        mode: '',
        device_id: []
      }
      this.group_id = null
      this.groupSelectedDevices = []
    },
    refresh() {
      this.getdata(this.formInline)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.green-bg {
  width: 20px;
  height: 10px;
  border-radius: 5px;
  margin: 5px 5px 0 0px;
  background-color: #0DAC78;
}

.red-bg {
  width: 20px;
  height: 10px;
  border-radius: 5px;
  margin: 5px 5px 0 0px;
  background-color: red;
}

.status {
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/views/device/group.vue